<template>
  <div class="result">
    <result-module
      :result="result"
      :sub-txt="subTxt"
      :view-txt="viewTxt"
      :button-txt="buttonTxt"
      @backHome="backHome"
      @viewClick="viewClick"
    >
      <!-- 话费充值不显示 -->
      <div
        slot="fail"
        v-if="orderStatus != '00' && orderType != '00'"
      >
        <div
          class="paid-fail"
          v-if="isRefund"
        >支付金额将在1-3个工作日退回原支付账户</div>
        <div
          class="third-fail"
          v-else
        >
          请稍候重试或联系客服<a style="color: #3399ff">4006000899</a>
        </div>
      </div>
    </result-module>
  </div>
</template>

<script>
import ResultModule from '@/components/result-module.vue';

// 订单类型
export const OrderTypeMap = {
  Phone: '00',
  Oil: '01',
  Gift: '02',
  Media: '03',
  ParkingViolations: '04',
  Ticket: '05'
};

export default {
  name: 'ResultPage',
  components: {
    ResultModule
  },
  data() {
    return {
      result: ' ',
      subTxt: '支付成功',
      viewTxt: '查看充值记录',
      countdown: 5,
      buttonTxt: '返回首页(5s)',
      orderNo: '',
      orderStatus: '03', // 00成功,01是第三方失败，03是已支付失败
      orderType: '02', // 订单类型 00,手机号充值，01油卡充值，02礼品卡充值 03视听卡 04违章  05罚单
      timer: null,
      isRefund: false // 是否为退款单
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      console.log(this.$route.query, 'this.$route.query');
      if (this.$route.query.orderNo) {
        this.orderNo = this.$route.query.orderNo;
      }
      if (this.$route.query.orderStatus) {
        this.orderStatus = this.$route.query.orderStatus;
      }
      if (this.$route.query.orderType) {
        this.orderType = this.$route.query.orderType;
      }
      if (this.$route.query.isRefund) {
        this.isRefund = this.$route.query.isRefund;
      }

      if (this.orderStatus === '02') {
        this.result = 'success';
      } else {
        this.result = 'fail';
      }

      if ([OrderTypeMap.Gift, OrderTypeMap.Media].includes(this.orderType)) {
        this.subTxt = '购买成功';
        this.viewTxt = '打开订单详情提取卡密码';
      }
      if (
        [OrderTypeMap.ParkingViolations, OrderTypeMap.Ticket].includes(this.orderType)
      ) {
        this.viewTxt = '查看订单详情';
      }

      if (!this.timer) {
        var that = this;
        that.timer = setInterval(function() {
          if (that.countdown <= 0) {
            that.backHome();
            clearInterval(that.timer);
            that.countdown = 5;
            that.buttonTxt = '返回首页(0s)';
          } else {
            that.countdown--;
            that.buttonTxt = '返回首页(' + that.countdown + 's)';
          }
        }, 1000);
      }
    },

    // 回首页事件
    backHome() {
      console.log('回首页事件');
      if (this.$browserEnv == 0) {
        const that = this;
        wx.miniProgram.navigateTo({
          url: '/pages/extend/index',
          success: function() {
            console.log('success');
            that.backHomeH5();
          },
          fail: function() {
            console.log('--- fail--- ');
            that.backHomeH5();
          },
          complete: function() {
            console.log('complete');
          }
        });
      } else {
        this.backHomeH5();
      }
    },
    backHomeH5() {
      if (this.orderType === OrderTypeMap.Phone) {
        this.$router.replace('phoneCharge');
      } else if (this.orderType === OrderTypeMap.Oil) {
        this.$router.replace('/refuelRecharge');
      } else if (this.orderType === OrderTypeMap.Gift) {
        this.$router.replace('/giftRecharge');
      } else if (this.orderType === OrderTypeMap.Media) {
        this.$router.replace('/chargeView');
      } else if (this.orderType === OrderTypeMap.ParkingViolations) {
        this.$router.replace({
          path: '/parkingViolationsCheck',
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.$route.query.categoryCode
          }
        });
      } else if (this.orderType === OrderTypeMap.Ticket) {
        this.$router.replace({
          path: '/ticketCheck',
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.$route.query.categoryCode
          }
        });
      }
    },

    // 查看记录
    viewClick() {
      if (this.orderType === OrderTypeMap.Phone) {
        this.$router.replace('phoneChargeRecords');
      } else if (this.orderType === OrderTypeMap.ParkingViolations) {
        this.$router.replace({
          path: '/pvOrderDetail',
          query: {
            orderNo: this.orderNo
          }
        });
      } else if (this.orderType === OrderTypeMap.Ticket) {
        this.$router.replace({
          path: '/ticketOrderDetail',
          query: {
            orderNo: this.orderNo
          }
        });
      } else if (this.orderType === OrderTypeMap.Gift) {
        this.$router.replace({
          path: '/giftOrderDetail',
          query: {
            orderNo: this.orderNo
          }
        });
      } else if (this.orderType === OrderTypeMap.Media) {
        this.$router.replace({
          path: '/mediaOrderDetail',
          query: {
            orderNo: this.orderNo
          }
        });
      } else if (this.orderType === OrderTypeMap.Oil) {
        this.$router.replace({
          path: '/refuelDetail',
          query: {
            orderNo: this.orderNo
          }
        });
      }
    }
  },
  onUnload() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss">
.result {
  width: 7.5rem;
  min-height: 100vh;
  padding-top: 12px;

  color: #383838;
  background-color: #f4f6f7;

  font-size: 0.32rem;

  .paid-fail {
    padding-top: 16px;

    text-align: center;

    color: #ff3333;
  }

  .third-fail {
    padding-top: 16px;

    text-align: center;

    color: #787878;
  }
}
</style>
